import { writable } from "svelte/store";

export const payload = writable<string>("");
